module.exports = __webpack_public_path__ + "img/elogo2025.5146004b.png";